<template>
    <div class="modal bookable-slot" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="card border-0">
                    <div class="card-body pb-sm-5 pb-5">
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="row mb-4 mt-4 mt-sm-5">
                                    <div class="col-12">
                                        <h2 class="text-2xl" v-html="header"></h2>
                                        <p v-show="isScheduled && !autoApproveBooking" class="text-sm text-elev-blue-dim">{{ $t('Denne forespørselen venter på bekreftelse fra læreren.') }}</p>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.date }}
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl">
                                        <strong>{{ slotData.start_time }}</strong>–{{ slotData.end_time }}
                                    </div>
                                </div>

                                <div class="row mb-3" v-if="slotData.teacher_name">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.teacher_name }}
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.price }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#7C889B">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ $t('{productName} klasse {className}', { productName: label, className: slotData.class_name }) }}
                                    </div>
                                </div>
                                <div class="row mb-3" v-if="slotData.location_text">
                                    <div class="col-2 col-sm-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#7C889B" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                        </svg>
                                    </div>
                                    <div class="col-10 col-sm-11 text-xl fw-bold">
                                        {{ slotData.location_text }}
                                    </div>
                                </div>

                                <!-- Buttons -->
                                <div class="mb-3">
                                    <a href="#" class="text-elev-blue-dim text-decoration-none btn-block btn btn-link font-weight-bolder" @click.prevent="navigateBack">{{ $t('Tilbake') }}</a>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-show="success !== null">
                            <div class="col-10 offset-1 text-center">
                                <div class="alert" :class="{ 'alert-danger': success === false, 'alert-success': success === true}">
                                    <p class="m-0" v-html="message"></p>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="(success === null || success === false) && isScheduled">
                            <div class="col-10 offset-1">
                                <button class="btn btn-danger btn-block py-3 fw-bold" @click.prevent="submitCancelRequest" :disabled="isRunningCancelRequest || isContact">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isRunningCancelRequest"></span>
                                    {{ cancelButtonText }}
                                </button>
                                <div v-if="isContact" class="my-2 text-sm fw-bold text-center">{{ $t('Kjøretimer kan kun kanselleres av eleven selv') }}</div>
                            </div>
                        </div>
                        <div class="row" v-if="(success === null || success === false) && !isScheduled && canCancelActivity">
                            <div class="col-10 offset-1">
                                <button class="btn btn-danger btn-block py-3 fw-bold" @click.prevent="submitCancelRequest" :disabled="isRunningCancelRequest || isContact">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isRunningCancelRequest"></span>
                                    {{ cancelActivityText }}
                                </button>
                                <div v-if="isContact" class="my-2 text-sm fw-bold text-center">{{ $t('Aktiviteter kan kun kanselleres av eleven selv') }}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import Store from '../../state/calendarStore'

const props = defineProps(['slotData', 'autoApproveBooking'])

// Reactive state
const cancelButtonText = ref($t('Kanseller bestilling'))
const cancelActivityText = ref($t('Kanseller aktivitet'))
const cancelConfirmed = ref(false)

// Computed
const isRunningCancelRequest = computed(() => Store.state.isRunningCancelRequest.value)
const label = computed(() => props.slotData.label)
const header = computed(() => {
    if (isScheduled.value) {
        return $t('<strong>Ubekreftet</strong><br> bestilling')
    }
    return $t('<strong>Planlagt</strong><br> aktivitet')
})
const isScheduled = computed(() => props.slotData.product_type === 11)
const success = computed(() => Store.state.requestSuccess.value)
const message = computed(() => Store.state.responseMessage.value)
const isContact = computed(() => Store.state.isContact.value)
const canCancelActivity = computed(() => props.slotData.can_cancel)

// Methods
function navigateBack() {
    Store.deselectSlot()
}

function submitCancelRequest() {
    if (isContact.value || isRunningCancelRequest.value) {
        return
    }
    if (cancelConfirmed.value) {
        return Store.cancelBooking(props.slotData.calendar_id)
    } else {
        cancelButtonText.value = $t('Er du sikker?')
        cancelActivityText.value = $t('Er du sikker?')
        cancelConfirmed.value = true
    }
}

// Event handlers
function onEscape(e) {
    if (e.keyCode === 27) {
        navigateBack()
    }
}

// Lifecycle hooks
onMounted(() => {
    document.addEventListener('keydown', onEscape)
})

onUnmounted(() => {
    document.removeEventListener('keydown', onEscape)
})
</script>
